/**
 * DIE FILTERKLAPPE (.617): EIN BAUTEIL FÜR NE3 UND NE4.
 *
 * ORIGINALTEXT MARVIN (03.11.2026, iPhone, NE3 neben NE4)
 *   „da ist halt das extra Menü zum Ausklappen, was das ein bisschen übersichtlicher macht. Bitte auch bei NE4 hier
 *    einbauen ... ich will, dass das Grundsystem identisch ist und wir das für die verschiedenen Arbeitsbereiche
 *    ein Stück weit klonen und erweitern ... Aber nicht alles einzelne Systeme, die entwickelt werden."
 *
 * Auf dem Schreibtisch ist die Klappe unsichtbar und die Reihen stehen offen da (stil.css, .filterklappe und
 * .filterfach). Auf dem Telefon (bis 860 px) steht ein Knopf mit der Auswahl („Alle Aufträge" oder die gewählten
 * Wörter), und die Reihen sind erst zu sehen, wenn er offen ist. Beide Listen (Arbeitsliste NE3, Aufträge NE4)
 * geben nur ihre Reihen und die gewählten Wörter herein; Aussehen und Verhalten gibt es einmal.
 */
import { useState, type ReactNode } from 'react';

export function Filterklappe({ worte, kennung = 'filterfach', children }: { worte: string[]; kennung?: string; children: ReactNode }) {
  const [offen, setOffen] = useState(false);
  return (
    <>
      <button type="button" className="filterklappe" aria-expanded={offen} aria-controls={kennung}
              data-gesetzt={worte.length ? 'ja' : 'nein'} onClick={() => setOffen(!offen)}>
        <span>Filter</span>
        <span className="filterklappewahl">{worte.length ? worte.join(', ') : 'Alle Aufträge'}</span>
        <svg className="filterpfeil" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
          <path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div id={kennung} className={'filterfach' + (offen ? ' offen' : '')}>{children}</div>
    </>
  );
}
